import React from 'react'
import './style.css'

const Spinner = () => {
  return <div className="spinner site-color"></div>  
}

export default Spinner
